const DATE_UI_RE = /^(\d{2})\.(\d{2})\.(\d{4})$/
const TIME_RE = /^(\d{2}):(\d{2})$/

export const isoDateToUi = (iso) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || '').trim())
  if (!match) return ''
  return `${match[3]}.${match[2]}.${match[1]}`
}

export const uiDateToIso = (value) => {
  const match = DATE_UI_RE.exec(String(value || '').trim())
  if (!match) return null
  return `${match[3]}-${match[2]}-${match[1]}`
}

export const normalizeTimeHm = (value, fallback = '00:00') => {
  const source = String(value || '').trim() || fallback
  return TIME_RE.test(source) ? source : null
}

const kyivPartsFromMs = (ms) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Kyiv',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(ms))
  const get = (type) => parts.find((part) => part.type === type)?.value
  return {
    dateUi: `${get('day')}.${get('month')}.${get('year')}`,
    time: `${get('hour')}:${get('minute')}`,
  }
}

const stampToMs = (value) => {
  if (value == null) return null
  if (typeof value.toMillis === 'function') return value.toMillis()
  if (typeof value.seconds === 'number') {
    return value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6)
  }
  if (typeof value._seconds === 'number') {
    return value._seconds * 1000 + Math.floor((value._nanoseconds || 0) / 1e6)
  }
  if (value instanceof Date) return value.getTime()
  const parsed = Date.parse(value)
  return Number.isNaN(parsed) ? null : parsed
}

export const timestampToKyivFields = (value, fallbackTime = '00:00') => {
  const ms = stampToMs(value)
  if (ms == null) {
    return { date: '', time: fallbackTime }
  }
  const parts = kyivPartsFromMs(ms)
  return { date: parts.dateUi, time: parts.time }
}

export const buildPeriodPayload = ({ startDate, startTime, endDate, endTime, openEnded }) => {
  const startsIso = uiDateToIso(startDate)
  const startsTime = normalizeTimeHm(startTime, '00:00')
  if (!startsIso || !startsTime) {
    return { ok: false, error: 'Вкажіть дату початку' }
  }

  if (openEnded) {
    return {
      ok: true,
      startsAt: { date: startsIso, time: startsTime },
      endsAt: null,
      openEnded: true,
    }
  }

  const endsIso = uiDateToIso(endDate)
  const endsTime = normalizeTimeHm(endTime, '23:59')
  if (!endsIso || !endsTime) {
    return { ok: false, error: 'Вкажіть дату завершення' }
  }

  return {
    ok: true,
    startsAt: { date: startsIso, time: startsTime },
    endsAt: { date: endsIso, time: endsTime },
    openEnded: false,
  }
}
